(() => {
  // src/scroll-reveal.ts
  window.HotelCollection = window.HotelCollection || {};
  window.HotelCollection.initScrollReveal = (elements, willClass, revealedClass, threshold = 0.2, rootMargin = "0px") => {
    let remaining = 0;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(revealedClass);
        observer.unobserve(entry.target);
        if (--remaining === 0) observer.disconnect();
      });
    }, { threshold, rootMargin });
    Array.from(elements).forEach((el) => {
      if (el.classList.contains(willClass) || el.classList.contains(revealedClass)) return;
      const { top, bottom } = el.getBoundingClientRect();
      if (top < window.innerHeight && bottom > 0) return;
      el.classList.add(willClass);
      observer.observe(el);
      remaining++;
    });
    return observer;
  };
})();
